import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api/client'
import { useAuthStore } from '@/stores/authStore'

export interface PrivacySettings {
  /** Whether employees without employee:read-all can see the company directory. */
  employeeDirectoryVisible: boolean
}

/**
 * What the company lets employees see of each other.
 *
 * <p>Closed until it says otherwise: if the setting cannot be read, the menu behaves as if the
 * directory is closed. The server applies the same rule to the directory itself, so a menu
 * that guessed open would only offer a screen that then showed one name.
 */
export function usePrivacySettings(): PrivacySettings {
  const signedIn = useAuthStore((state) => state.user !== null)
  const query = useQuery({
    queryKey: ['settings', 'privacy'],
    enabled: signedIn,
    queryFn: async () => (await apiClient.get<PrivacySettings>('/v1/settings/privacy')).data,
    staleTime: 5 * 60_000,
    retry: false,
  })
  return { employeeDirectoryVisible: query.data?.employeeDirectoryVisible ?? false }
}
